var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.638672)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9116",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.638672",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9116)" } }, [
        _c("path", {
          attrs: { d: "M46.6387 0H0.638672V46H46.6387V0Z", fill: "#FFDC5F" },
        }),
        _c("path", {
          attrs: {
            d: "M0.638672 45.996C0.638672 33.2935 10.9361 22.9961 23.6386 22.9961H46.6387V45.996H0.638672Z",
            fill: "#FF9110",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.638672 0C0.638672 12.7026 10.9361 23.0001 23.6386 23.0001H46.6387V0H0.638672Z",
            fill: "#FFC040",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }